<template>
  <el-select v-bind="$attrs" :data-testid="testid" :placeholder="placeholder || $t('common.select.placeholder')" v-on="$listeners">
    <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
    <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data" />
    </template>
    <template v-if="options && options.length">
      <BaseElSelectOption
        v-for="opt in options"
        :key="opt.value"
        :label="opt.label"
        :value="opt.value"
      />
    </template>
  </el-select>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  testName: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
  },
  options: {
    type: Array,
    default: () => [],
  },
})

const testidRoot = 'el-select'

const testid = computed(() => {
  return props.testName ? `${testidRoot}-${props.testName}` : testidRoot
})
</script>
